import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const TicketService = sdk.getService('TicketService');

export const usePendingOpenTickets = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['tickets', 'count', 'open'],
    queryFn: () => TicketService.getPendingOpenTickets()
  });

  return {
    pendingTickets: data ?? 0,
    isLoading,
    error
  };
};
